// extracted by mini-css-extract-plugin
export default {"awardsHeading":"AwardsAchievementsPage_awardsHeading__g+K0c"};